import {Service} from "@/services/Service";

export class EventosService extends Service {
    constructor(axios) {
        super(axios, "");
    }

    registarEvento(datos) {
        this.onStart();
        return this.http.post(
                this.getUrl(['/registarEvento/']),
                datos,
                {
                    headers: {
                        'Content-Type': `multipart/form-data`,
                    },
                })
            .then((response) => response)
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerRegistrosEventos(numeroEmpleado) {
        this.onStart();
        return this.http.get(this.getUrlQuery(['/obtenerRegistrosEventos/'], [numeroEmpleado]))
            .then((response) => JSON.parse(response.data))
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerOptAreasEmpleado(numeroEmpleado) {
        this.onStart();
        return this.http.get(this.getUrlQuery(['/obtenerOptAreasEmpleado/'], [numeroEmpleado]))
            .then((response) => JSON.parse(response.data))
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}